<div class="message-container" *ngIf="messageService.messages.length">
  <div class="clear position-right"
          (click)="messageService.clear()"
  ><mat-icon>close</mat-icon></div>
  <ng-container *ngFor="let message of messageService.messages">
    <p [ngClass]="{
    'error': message.type === 'error',
    'success': message.type === 'success',
    'info': message.type === 'info'
    }">
      <mat-icon *ngIf="message.type === 'error'">error</mat-icon>
      <mat-icon *ngIf="message.type === 'success'">check_circle</mat-icon>
      <mat-icon *ngIf="message.type === 'info'">info</mat-icon>
      {{ message.message }}
    </p>
  </ng-container>
</div>
